<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="메뉴 관리" :IsUseInnerAddition="true" device="web">
        <template v-slot:innerAddition>
          <div>
            <v-btn class="ml-1" elevation="0" height="15" width="15" x-small color="white" @click="expandAllBtn((expand = !expand))">
              <v-icon>mdi mdi-arrow-expand-vertical</v-icon>
            </v-btn>
          </div>
          <v-row no-gutters align="center" class="pa-0 pt-2">
            <v-text-field class="search-text-field mx-1" label="통합 검색" outlined dense hide-details="auto" @change="changeInput" clearable />
            <v-radio-group v-model="selectedSvcGubn" row class="pl-4 pt-0">
              <v-radio
                color="radio"
                v-for="(item, index) in svcGubnSelectDataSource"
                :key="index"
                :label="item.minorNm"
                v-model="item.minorCd"
              ></v-radio>
            </v-radio-group>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" lg="12" class="pa-0">
                <DxTreeList
                  id="menuManageTreeList"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxTreeListRef"
                  :data-source="menus"
                  :hover-state-enabled="true"
                  :show-row-lines="true"
                  :show-borders="true"
                  :column-auto-width="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :focused-row-enabled="true"
                  :root-value="0"
                  data-structure="plain"
                  key-expr="menuId"
                  parent-id-expr="parentId"
                  @editor-preparing="onEditorPreparing"
                  @selection-changed="onSelectionChanged"
                  @row-updated="onRowUpdated"
                  @row-updating="onRowUpdating"
                  @focused-row-changed="onFocusedRowChanged"
                  @cellClick="onCellClick"
                >
                  <!-- 선택모드  -->
                  <DxSelection mode="multiple" />

                  <DxScrolling mode="standard" row-rendering-mode="standard" />
                  <!-- mode : "multiple" | "none" -->
                  <!-- 드래그 -->
                  <DxRowDragging
                    :on-drag-change="onDragChange"
                    :on-reorder="onReorder"
                    :allow-drop-inside-item="true"
                    :allow-reordering="true"
                    :show-drag-icons="true"
                  />
                  <!-- 수정 -->
                  <DxEditing :allow-updating="true" mode="batch" :select-text-on-edit-start="true" />

                  <DxColumn data-field="platformType" caption="플랫폼타입" :visible="false" />
                  <DxColumn data-field="menuNm" width="220px" caption="메뉴명" css-class="devest-grid-header-require" />
                  <DxColumn data-field="menuId" width="80px" caption="메뉴ID" :allow-editing="false" />
                  <DxColumn data-field="menuEngNm" width="210px" caption="메뉴영문명" />

                  <DxColumn data-field="svcGubn" data-type="string" caption="웹/모바일" width="80px" alignment="center">
                    <DxLookup :data-source="svcGubnDataSource" display-expr="minorNm" value-expr="minorCd">
                      <DxDropDownOptions :full-screen="true" />
                    </DxLookup>
                  </DxColumn>
                  <DxColumn data-field="progCd" caption="프로그램명" width="270px">
                    <DxLookup :data-source="menuProgDataSource" display-expr="progNm" value-expr="progCd" />
                  </DxColumn>
                  <DxColumn sortOrder="asc" width="80px" data-field="sort" caption="순서" alignment="right" />
                  <DxColumn
                    data-field="useYn"
                    data-type="boolean"
                    caption="사용"
                    width="80px"
                    edit-cell-template="checkBoxEditor"
                    :allow-sorting="false"
                    header-cell-template="title-header"
                  />
                  <DxColumn
                    data-field="menuListYn"
                    data-type="boolean"
                    caption="가시화"
                    width="80px"
                    edit-cell-template="checkBoxEditor"
                    :allow-sorting="false"
                    header-cell-template="title-header"
                  />

                  <DxColumn data-field="svcType" caption="서비스타입" width="100px" alignment="center">
                    <DxLookup :data-source="svcTypeDataSource" display-expr="minorNm" value-expr="minorCd" />
                  </DxColumn>
                  <DxColumn
                    data-field="menuIcon"
                    caption="메뉴아이콘"
                    cell-template="menuIconCellTemplate"
                    edit-cell-template="menuIconEditor"
                    width="180px"
                  ></DxColumn>
                  <!-- checkbox -->
                  <template #checkBoxEditor="{ data: cellInfo  }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :on-value-changed="value => onCheckValueChanged(value, cellInfo)" />
                  </template>

                  <!-- menuIcon -->
                  <template #menuIconCellTemplate="{ data: cellInfo  }">
                    <div>
                      <v-icon>{{ cellInfo.value }}</v-icon>
                      {{ cellInfo.value }}
                    </div>
                  </template>
                  <!-- menuIcon -->
                  <template #menuIconEditor="{ data: cellInfo  }">
                    <DxSelectBox
                      :data-source="iconListDataSource"
                      :value="cellInfo.value"
                      display-expr="minorCd"
                      value-expr="minorCd"
                      :show-clear-button="false"
                      @value-changed="value => onMenuIconChanged(value.value, cellInfo)"
                      item-template="item"
                      :search-enabled="true"
                    >
                      <template #item="{ data }">
                        <div v-if="data">
                          <v-icon>{{ data.minorCd }}</v-icon>
                          {{ data.minorCd }}
                        </div>
                      </template>
                    </DxSelectBox>
                  </template>
                  <!-- 사용유무 헤더 -->
                  <template #title-header="{ data }">
                    <div>
                      <DxCheckBox :on-value-changed="value => onCheckHeaderValueChanged(value.value, data.column.name)" />
                      {{ data.column.caption }}
                    </div>
                  </template>
                </DxTreeList>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right :useBtnList="buttonUseList" @btnAdd="btnAdd()" @btnSearch="btnSearch()" @btnSave="btnSave()" @btnDelete="btnDelete()">
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import iPageTitle from '@/components/common/iPageTitle.vue'
import iButtonList from '@/components/common/iButtonList.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import {
  DxTreeList,
  DxSelection,
  DxColumn,
  DxRowDragging,
  DxEditing,
  DxLookup,
  DxPager,
  DxScrolling,
  DxDropDownOptions
} from 'devextreme-vue/tree-list'
import DxTextBox from 'devextreme-vue/text-box'
import DxSelectBox from 'devextreme-vue/select-box'
import DxCheckBox from 'devextreme-vue/check-box'
import { getMenuProg, getMenuManage, saveMenuManage, deleteMenuManage } from '@/api/setting/menuManage'
import { getCommonCode } from '@/api/common/commonApi'

import notify from 'devextreme/ui/notify'
import Baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

export default {
  extends: Baseview, //20220414 LYJ base page 추가
  name: 'menuManage',
  components: {
    'i-page-title': iPageTitle,
    iCardVertical,
    'i-card-top': iCardTop,
    iButtonList,
    DxTreeList,
    DxSelection,
    DxColumn,
    DxRowDragging,
    DxEditing,
    DxCheckBox,
    DxTextBox,
    DxSelectBox,
    DxLookup,
    DxDropDownOptions,
    DxPager,
    DxScrolling
  },
  data() {
    return {
      pageSizes: 17,
      showPageSizeSelector: false,
      dxTreeListRef: 'menuManageTreeList',
      menus: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      selectedSvcGubn: 'W',
      iconListDataSource: [],
      svcGubnDataSource: [],
      svcGubnSelectDataSource: [],
      menuProgDataSource: [],
      selectedItemKeys: [],
      svcTypeDataSource: [],

      focusedRow: null,
      isLoding: false,
      expand: false
    }
  },
  beforeMount() {
    Promise.all([
      getMenuProg(), // 프로그램 리스트 들고오기
      getCommonCode('CM004'), // majorCd : "CM004" 프로그램 Type
      getCommonCode('CM005'), // majorCd : "CM005" 메뉴 아이콘
      getCommonCode('CM010') // majorCd : "CM010" 서비스타입 N : 일반, P : 준비중, I : 점검중
    ]).then(res => {
      let failedResponse = res.find(element => !element.success)
      if (failedResponse == null) {
        // 프로그램 리스트 들고오기
        this.menuProgDataSource = []
        this.menuProgDataSource = res[0].list
        this.menuProgDataSource.push({ progCd: '', progNm: '', progIcon: '' })
        this.menuProgDataSource.unshift({ progCd: '', progNm: '', progIcon: '' })

        // majorCd : "CM004" 프로그램 Type
        this.svcGubnDataSource = []
        this.svcGubnDataSource = res[1].list
        this.svcGubnSelectDataSource = this.svcGubnDataSource.slice()

        // majorCd : "CM005" 메뉴 아이콘
        this.iconListDataSource = []
        this.iconListDataSource = res[2].list
        this.iconListDataSource.push({ minorCd: '', minorNm: '' })
        this.iconListDataSource.unshift({ minorCd: '', minorNm: '' })

        // majorCd : "CM010" 서비스타입
        this.svcTypeDataSource = []
        this.svcTypeDataSource = res[3].list
      } else {
        // this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'warn')
      }
    })
  },
  mounted() {
    // 켜질때 조회
    this.btnSearch()
  },
  computed: {
    treeList: function() {
      //onRowClick
      console.log(this.$refs[this.dxTreeListRef].instance)
      return this.$refs[this.dxTreeListRef].instance
    }
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    changeInput(value) {
      this.treeList.searchByText(value)
    },
    async btnAdd() {
      // 부모 메뉴 ID
      let parent = null
      let parentId = 0
      let level = 0
      let selectedRows = await this.treeList.getSelectedRowsData()
      // 포커싱된 데이터가 있으면
      if (this.focusedRow !== null) {
        // 부모아이디 세팅
        parentId = this.focusedRow.menuId
        // level 세팅(선택 하위로 들어가니 + 1)
        // batch 로 변경되며 사용이 안됨
        // level = this.treeList.getNodeByKey(this.focusedRow.menuId).lvl + 1
        level = this.menus.find(element => element.menuId === this.focusedRow.menuId).lvl + 1

        // 생성될 부모 노드 확장
        this.treeList.expandRow(this.focusedRow.menuId)
      }
      // 첫번째로 선택된 열의 메뉴 아이디로 부모아이디 생성 및 레벨 세팅
      else if (selectedRows.length !== 0) {
        // 부모아이디 세팅
        parentId = selectedRows[0].menuId
        // level 세팅(선택 하위로 들어가니 + 1)
        // level = this.treeList.getNodeByKey(parentId).level + 1
        level = this.menus.find(element => element.menuId === parentId).lvl + 1

        // 생성될 부모 노드 확장
        this.treeList.expandRow(selectedRows[0].menuId)
      }

      // 메뉴ID는 Mapper에서 지정되므로 중복되지않는 임의의 값을 넣어준다.

      let newRow = {
        menuId: this.menus.length + 1,
        platformType: 'M',
        parentId,
        sort: 0,
        lvl: level,
        svcGubn: this.selectedSvcGubn.toString().replace(0, ''),
        useYn: 'Y'
      }

      // if(newRow.id == null) newRow.id = this.dataSource.length + 1;
      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.menus.unshift(newRow)
    },
    btnSearch() {
      this.openLoading()
      this.treeInit()
      let params = {
        platformType: 'M',
        svcGubn: this.selectedSvcGubn.toString().replace(0, '')
      }

      // 조회 api
      getMenuManage(params, true)
        .then(res => {
          this.menus = res.list
          // DxtreeList 버그로 인하여 전체확장을 껏다가 킴
          // this.treeList.option('autoExpandAll', false)
          // this.treeList.option('autoExpandAll', true)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      let selectedRows = await this.treeList.getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        // this.$vToastify.warning({ body: this.$t('selectionData') })
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.menuSave(selectedRows).then(res => {
            return true
          })
        },
        null,
        true
      )
    },
    async menuSave(selectedRows) {
      this.treeList.saveEditData()
      // let selectedRows = this.treeList.getSelectedRowsData()

      let valCheckData = selectedRows.findIndex(element => element.menuNm == null || element.menuNm.replace(/\s/g, '') == '')

      //필수값 체크
      if (valCheckData >= 0) {
        this.vToastify(this.$t('필수항목 입력하세요.[메뉴명]'), 'warn')
        // this.$vToastify.warning({ body: this.$t('필수항목 입력하세요.[메뉴명]') })
        return
      }

      let checkSelect = false
      for (let i = 0; i < selectedRows.length; i++) {
        // batch mode 로 바꾸면서 제대로 동작하지않음
        // let sourceNode = this.treeList.getNodeByKey(selectedRows[i].menuId)
        let sourceNode = this.menus.find(element => element.menuId === selectedRows[i].menuId)

        // 신규 열이 선택되면 자신의 부모중에 신규가 있는지 파악하고 그 부모신규도 체크가 되어야함
        checkSelect = await this.isSelectAllparent(sourceNode)

        if (checkSelect) break
      }

      if (checkSelect) {
        this.vToastify(this.$t('저장할 메뉴의 상위메뉴 중 체크가 안된 신규 상위메뉴가 있습니다.'), 'warn')
        // this.$vToastify.warning({ body: this.$t('저장할 메뉴의 상위메뉴 중 체크가 안된 신규 상위메뉴가 있습니다.') })
        return
      }

      // 선택한 열들에 level 값을 넣어주는것
      // this.setSelectedRowLevel(selectedRows)
      this.openLoading()
      // 트리구조로 변경
      let treeData = this.convertTreeStructure(selectedRows)
      // 저장 api
      return new Promise(resolve => {
        saveMenuManage(treeData, true)
          .then(res => {
            // 조회 api
            let params = {
              svcGubn: this.selectedSvcGubn.toString().replace(0, '')
            }
            getMenuManage(params, false)
              .then(res => {
                this.treeInit()
                this.menus = res.list
                // DxtreeList 버그로 인하여 전체확장을 껏다가 킴
                // this.treeList.option('autoExpandAll', false)
                // this.treeList.option('autoExpandAll', true)
              })
              .catch(error => {
                if (error.response && error.response.data) {
                  if (error.response.data.code == -2001) {
                    this.vToastify(this.$t(error.response.data.msg), 'warn')
                  }
                }
              })
              .finally(res => {
                this.endLoading()
                resolve(true)
              })
          })
          .finally(res => {
            this.endLoading()
            resolve(true)
          })
      })
    },
    async btnDelete() {
      let selectedRows = await this.treeList.getSelectedRowsData()
      if (selectedRows.length === 0) {
        // this.$vToastify.warning({ body: '선택된 데이터가 없습니다.' })
        this.vToastify(this.$t('선택된 데이터가 없습니다.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('메뉴를 삭제하시겠습니까?'),
        'info',
        current => {
          current.treeList.saveEditData()
          // 삭제 시 자식이 있는지 파악
          let checkChildren = false
          for (let i = 0; i < selectedRows.length; i++) {
            // getNodeByKey 가 적용이 안되어 방법 수정
            // let sourceNode = current.treeList.getNodeByKey([selectedRows[i].menuId])
            // 삭제 시 자식이 있는지 파악
            // checkChildren = sourceNode.hasChildren

            // 삭제 시 자식이 있는지 파악
            let findIndex = this.menus.findIndex(element => element.parentId === selectedRows[i].menuId)
            checkChildren = findIndex > -1 ? true : false
            if (checkChildren) break
          }
          // 자식이 있으면 한번 더 물어봄
          if (checkChildren) {
            this.vToastifyPrompt(
              current.$t('상위 메뉴를 삭제하시면 하위메뉴 전부 삭제됩니다. 진행하시겠습니까?'),
              'info',
              current => {
                this.openLoading()
                // 삭제
                deleteMenuManage(selectedRows, true)
                  .then(res => {
                    // this.menus 에서도 삭제
                    current.deleteCallBack(selectedRows)
                    return true
                  })
                  .finally(res => {
                    this.endLoading()
                  })
              },
              null,
              true
            )
          } else {
            this.openLoading()
            // 자식이 없으면 삭제
            deleteMenuManage(selectedRows, true)
              .then(res => {
                // this.menus 에서도 삭제
                current.deleteCallBack(selectedRows)
                return true
              })
              .finally(res => {
                this.endLoading()
              })
          }
        },
        null,
        true
      )
    },
    ///////////////////////////////////////
    /*        TreeList Event Event       */
    ///////////////////////////////////////
    expandAll() {
      this.treeList.forEachNode(node => this.treeList.expandRow(node.key))
    },
    collapseAll() {
      this.treeList.forEachNode(node => this.treeList.collapseRow(node.key))
    },
    expandAllBtn(expand) {
      if (expand == true) {
        this.expandAll()
      } else {
        this.collapseAll()
      }
    },
    setSelectedRowLevel(selectedRows) {
      for (let i = 0; i < selectedRows.length; i++) {
        // 레벨 세팅
        let key = selectedRows[i].menuId

        // batch 로 변경되며 제대로 동작이 안됨
        // let level = this.treeList.getNodeByKey(key).level
        let level = this.menus.find(element => element.menuId === key).level

        selectedRows[i].lvl = level
      }
    },
    onEditorPreparing(e) {
      // onCellValueChanged 를 사용하기 위함
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)

      // treelist는 clearSelection() 시 onCellValueChanged를 더 타므로 loading 변수로 제어한다.
      if (!this.isLoding) this.treeList.selectRows(cellInfo.row.key, true)

      // 프로그램이 바뀌면 기본 메뉴 아이콘값이 메뉴 아이콘으로 자동 세팅
      if (cellInfo.dataField === 'progCd') {
        let progData = this.menuProgDataSource.find(element => element.progIcon != null && element.progIcon === value)

        cellInfo.component.cellValue(cellInfo.row.rowIndex, 'menuIcon', progData != null && progData.progIcon != null ? progData.progIcon : '')
      }
    },
    async onSelectionChanged(e) {
      // 최근에 선택된 열의 node 정보
      let sourceNode
      if (e.currentSelectedRowKeys.length !== 0) {
        sourceNode = this.treeList.getNodeByKey(e.currentSelectedRowKeys)
      } else {
        sourceNode = this.treeList.getNodeByKey(e.currentDeselectedRowKeys)
      }

      // 열 삭제시에도 해당 메소드를 타기때문에 return
      if (sourceNode == null) return

      // 최근 선택된 열의 menuId
      // let currentSelectedMenuId = sourceNode.data.menuId

      // // 하위 노드에 대한 선택들
      // let isRowSelected = this.treeList.isRowSelected(currentSelectedMenuId)
      // if(sourceNode.children.length !== 0) {
      //   this.menus.forEach(element =>{
      //     if(element.parentId === currentSelectedMenuId) {
      //       // 순서가 바뀌어서 변하였으니 저장하기 위해 선택 check
      //       if(isRowSelected) {
      //         this.treeList.selectRows([`${element.menuId}`], true)
      //       } else {
      //         this.treeList.deselectRows([`${element.menuId}`])
      //       }
      //     }
      //   })
      // }
    },
    onRowUpdated(e) {
      // 열 수정시 선택되게함
      e.data.__modified__ = true
      this.treeList.selectRows(e.key, true)
    },
    onRowUpdating(e) {
      this.treeList.selectRows(e.key, true)
    },
    onDragChange(e) {
      // visibleRows : 현재 보이는 열, sourceNode : 옮기고 있는 열의 node 정보, targetNode : sourceNode와 대응하는 열의 node 정보
      let visibleRows = this.treeList.getVisibleRows(),
        sourceNode = this.treeList.getNodeByKey(e.itemData.menuId),
        targetNode = visibleRows[e.toIndex].node
      //부모 노드가 하위 노드로 들어가는것을 방지
      while (targetNode && targetNode.data) {
        if (targetNode.data.menuId === sourceNode.data.menuId) {
          e.cancel = true
          break
        }
        targetNode = targetNode.parent
      }
    },
    onReorder(e) {
      // visibleRows : 현재 보이는 열, sourceData : 옮기고 있는 열, targetData : targetData와 대응하는 열
      let visibleRows = e.component.getVisibleRows(),
        sourceData = e.itemData,
        targetData = visibleRows[e.toIndex].data

      // 드래그된 Row가 Select된 상태로 되는것
      let getSelectedRowIds = []
      this.treeList.getSelectedRowsData().forEach(element => {
        getSelectedRowIds.push(element.menuId)
      })
      getSelectedRowIds.push(sourceData.menuId)
      this.treeList.selectRows(getSelectedRowIds)

      // 안에 넣는다면
      if (e.dropInsideItem) {
        e.itemData.parentId = targetData.menuId
        // 넣어진 열이 맨 마지막 순서로 들어감
        e.itemData.sort = visibleRows[e.toIndex].node.children.length + 1
      } else {
        let sourceIndex = this.menus.indexOf(sourceData),
          targetIndex = this.menus.indexOf(targetData)

        // 부모가 다르면
        if (sourceData.parentId !== targetData.parentId) {
          sourceData.parentId = targetData.parentId
          if (e.toIndex > e.fromIndex) {
            targetIndex++
          }
        }

        this.menus.splice(sourceIndex, 1)
        this.menus.splice(targetIndex, 0, sourceData)
      }

      // 레벨 세팅
      let level = this.treeList.getNodeByKey(sourceData.menuId).level
      sourceData.lvl = level

      let sourceNode = e.component.getNodeByKey(e.itemData.menuId)

      // 옮겨졌던 열의 같은 레벨의 아이들의 순서를 자동으로 넣어주는것
      let i = 1
      this.menus.forEach(element => {
        // 제일 최상위 레벨 || 그 외 레벨
        if (
          (typeof sourceNode.parent.data === 'undefined' && element.parentId === 0) ||
          (typeof sourceNode.parent.data !== 'undefined' && element.parentId === sourceNode.parent.data.menuId)
        ) {
          element.sort = i
          i++
          // 순서가 바뀌어서 변하였으니 저장하기 위해 선택 check
          this.treeList.selectRows([`${element.menuId}`], true)
        }
      })

      this.treeList.refresh()
    },
    // 체크박스 값 변경될 시 타는 이벤트
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')

      // 재귀적으로 트리아래 모든 데이터 변경을 위한 함수
      this.recursiveDataChange(cellInfo)
      this.treeList.selectRows(cellInfo.row.key, true)

      cellInfo.component.updateDimensions()
    },
    // 메뉴 아이콘 안의 아이콘 변경시
    onMenuIconChanged(value, cellInfo) {
      cellInfo.setValue(value)
      cellInfo.component.updateDimensions()
    },
    onFocusedRowChanged(e) {
      // const rowData = e.row && e.row.data;
      // let cellValue;
      // let assigned;

      if (e.row != null) {
        this.focusedRow = e.row.data
      }

      // if (rowData) {
      //   cellValue = e.component.cellValue(e.row.rowIndex, 'menuId');
      // }
    },
    onCellClick(e) {
      if (e.rowType === 'header' && e.column.dataField === 'useYn') {
        // 헤더 체크박스 누를 시 sort 안되게하는것 추후 개발
        // e.event.stopImmediatePropagation()
        // e.event.stopPropagation()
        // window.event.cancelBubble = true
      }
    },
    // 헤더의 값 변경될 시 타는 이벤트
    onCheckHeaderValueChanged(value, headerField) {
      this.menus.forEach(element => {
        element[headerField] = value ? 'Y' : 'N'
      })
      this.treeList.selectAll()
    },
    async treeInit() {
      this.treeList.option('focusedRowIndex', -1)
      this.isLoding = true
      await this.treeList.clearSelection()
      this.isLoding = false
      this.treeList.cancelEditData()
      this.focusedRow = null
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index1 = null
      selectedRows.forEach(key => {
        index1 = this.menus.findIndex(obj => obj == key)
        this.menus.splice(index1, 1)
      })
    },
    convertTreeStructure(list) {
      // lvl 별로 정렬
      this.sortByLevel(list)
      let map = {},
        node = {},
        roots = []

      for (let i = 0; i < list.length; i += 1) {
        // 초기세팅
        map[list[i].menuId] = i
        list[i].children = []
      }

      for (let i = 0; i < list.length; i += 1) {
        node = list[i]
        if (node.parentId !== 0) {
          // 부모가 없는 가지는 맨 위로 보낸다.
          if (typeof list[map[node.parentId]] === 'undefined') {
            roots.push(node)
          } else {
            list[map[node.parentId]].children.push(node)
          }
        } else {
          roots.push(node)
        }
      }
      return roots
    },
    // lvl 별로 정렬
    sortByLevel(array) {
      array = array.sort(function(a, b) {
        return a.lvl - b.lvl
      })
    },
    // 저장시 열이 선택되면 자신의 부모중에 신규가 있는지 파악하고 그 부모신규도 체크가 되어야함
    async isSelectAllparent(selectedNode) {
      let parentId = selectedNode.parentId
      let check = false
      while (parentId !== 0) {
        // 부모노드 가져옴
        // batch 로 바꾸면서 제대로 동작하지않음
        // let parentNode = this.treeList.getNodeByKey(parentId)
        let parentNode = this.menus.find(element => element.menuId === parentId)

        //부모가 신규면
        if (parentNode.__created__) {
          // 부모가 신규이면서 자식은 체크되었지만 부모가 체크가 안된경우
          if (!this.treeList.isRowSelected(parentNode.menuId)) {
            check = true

            break
          }
        }
        parentId = parentNode.parentId
      }
      return check
    },
    // 재귀적으로 트리아래 모든 데이터 변경을 위한 함수
    recursiveDataChange(cellInfo) {
      this.menus.forEach(element => {
        if (element.parentId === cellInfo.data.menuId) {
          // 순서가 바뀌어서 변하였으니 저장하기 위해 선택 check
          element[`${cellInfo.column.dataField}`] = cellInfo.value
          // 재귀적으로 함수를 타기위해 cellInfo 만들어줌
          let tempCellInfo = {
            data: {
              menuId: element.menuId
            },
            column: {
              dataField: cellInfo.column.dataField
            },
            value: cellInfo.value
          }
          this.treeList.selectRows([`${element.menuId}`], true)
          this.recursiveDataChange(tempCellInfo)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
/// title 옆에 확장 아이콘 추가 230207 bys
::v-deep .v-card__title {
  display: flex;
  justify-content: space-between !important;
  width: 100%;
}

::v-deep .spacer,
::v-deep .v-card__title .iButtonList {
  display: none !important;
}
</style>
